import { useQuery } from 'react-query';

import { getTrackedItems as queryFn } from 'api/endPoints/getTrackedItems';

export const useQueryVersionCompareTrackedActivitiesTableData = (params) => {
    return useQuery(['versionCompareTrackedActivitieTableData', params], () => queryFn(params), {
        enabled: Boolean(params.compareVersionId) && Boolean(params.latestVersionId),
    });
};
